export default __webpack_public_path__ + "static/MerriweatherSans-Regular-9ab233598abd51d09b0df94a4cbfd01b.ttf";